export enum WorkerFileTypeEnum {
  PreeliminaryMedicalExamination = 9,
  EmploymentCertificate = 11,
  WorkerFamilyMember = 12,
  EducationHistoryRecordFile = 15,
  LegalizationFile = 22
}
